import { getLocale } from '!/common/helpers';

const AppliedFilterItem = props => {
  const { attribute, name, onClick } = props;
  const getLabel = _ => {
      if (attribute === 'price_range') {
          return name.join('-').replace("76", "75+") + " €";
      } else if (attribute === 'averageRating') {
          return `${name[0]}+ Stars`;
      }
      else {
          return name;
      }
  };

  return (
    <li>
      <button
        value={name}
        className="btn btn--small btn--outline btn--applied-filters"
        attribute={attribute}
        onClick={() => onClick(attribute, name)}
      >
        {getLabel()}&nbsp;<span>&times;</span>
      </button>
    </li>
  );
};

export default AppliedFilterItem;
